import { render, staticRenderFns } from "./OrganizationRoles.vue?vue&type=template&id=f33cebc8&"
import script from "./OrganizationRoles.vue?vue&type=script&lang=ts&"
export * from "./OrganizationRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports